'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Layout from 'Layouts/Back';
import Link from 'Pure/Link';
import { front_urls, URL } from 'Shared/Routes';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import { action } from 'Shared/Routes';
let app = window.app;
export default class AdminGlobalIndicatorPage extends Component {
  state = {
    start_date: "",
    end_date: "",
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.getCA({});
    component.getCAWithoutServices({});
    component.getCartAverage({});
    component.getCartAverageWithoutServices({});
    component.getTransactionCount({});
    component.getSubscriptionCount({});
  }
  handleFilterChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
    component.getCA({
      [name]: value
    });
    component.getCAWithoutServices({
      [name]: value
    });
    component.getCartAverage({
      [name]: value
    });
    component.getCartAverageWithoutServices({});
    component.getTransactionCount({
      [name]: value
    });
    component.getSubscriptionCount({
      [name]: value
    });
  };
  getCA = ({
    start_date,
    end_date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/stat/get-ca', {
      start_date: typeof start_date === "undefined" ? state.start_date : start_date,
      end_date: typeof end_date === "undefined" ? state.end_date : end_date
    }).then(function (xhr, response) {
      component.setState({
        ca: response.ca,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getCAWithoutServices = ({
    start_date,
    end_date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/stat/get-ca-without-services', {
      start_date: typeof start_date === "undefined" ? state.start_date : start_date,
      end_date: typeof end_date === "undefined" ? state.end_date : end_date
    }).then(function (xhr, response) {
      component.setState({
        ca_without_services: response.ca_without_services,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getCartAverage = ({
    start_date,
    end_date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/stat/get-cart-average', {
      start_date: typeof start_date === "undefined" ? state.start_date : start_date,
      end_date: typeof end_date === "undefined" ? state.end_date : end_date
    }).then(function (xhr, response) {
      component.setState({
        average: response.average,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getCartAverageWithoutServices = ({
    start_date,
    end_date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/stat/get-cart-average-without-services', {
      start_date: typeof start_date === "undefined" ? state.start_date : start_date,
      end_date: typeof end_date === "undefined" ? state.end_date : end_date
    }).then(function (xhr, response) {
      component.setState({
        average_without_services: response.average_without_services,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getTransactionCount = ({
    start_date,
    end_date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/stat/get-transaction-count', {
      start_date: typeof start_date === "undefined" ? state.start_date : start_date,
      end_date: typeof end_date === "undefined" ? state.end_date : end_date
    }).then(function (xhr, response) {
      component.setState({
        transaction_count: response.transaction_count,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  getSubscriptionCount = ({
    start_date,
    end_date
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/stat/get-subscription-count', {
      start_date: typeof start_date === "undefined" ? state.start_date : start_date,
      end_date: typeof end_date === "undefined" ? state.end_date : end_date
    }).then(function (xhr, response) {
      component.setState({
        subscription_count: response.subscription_count,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Global"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "o-content dashboard-page"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters c-filters--users"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['start_date'] || "",
      className: "cutom-date-picker",
      name: "start_date",
      label: "Date de d\xE9but",
      "allow-no-value": true,
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("div", {
      className: "c-filters__element"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleFilterChange,
      value: state['end_date'] || "",
      className: "cutom-date-picker",
      name: "end_date",
      label: "Date de fin",
      "allow-no-value": true,
      status: state.status_messages
    }))), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table u-margin-bottom-25",
      style: {
        overflow: 'initial'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-stats"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title"
    }, "CA"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, state?.ca + '€')), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title"
    }, "CA hors service"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, state?.ca_without_services + '€')), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title"
    }, "Panier moyen"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, state?.average + '€')), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title"
    }, "Panier moyen hors service"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, state?.average_without_services + '€')), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title"
    }, "Nombre de transactions"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, state?.transaction_count)), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "c-stats__item-title"
    }, "Nombre total d'abonnement"), /*#__PURE__*/React.createElement("div", {
      className: "c-stats__item-result"
    }, state?.subscription_count))))));
    return output;
  }
}
